var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-1"},[_c('dv-digital-flop',{staticStyle:{"width":"100%","height":"4rem"},attrs:{"config":_vm.digitalConfig1}}),_c('dv-digital-flop',{staticStyle:{"width":"100%","height":"4rem"},attrs:{"config":_vm.digitalConfig12}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }